<template>
<div class="tw_dashboard_notification notification_list" :class="{edit: isEditMode, disabled: isDisabled}">
  <tw-table-system :schemas="schemas" :height="272" :nopager="true" :items="items" @row-click="rowClick" :class='{unread: true}' mode="NOTIFICATION" />
</div>
</template>

<script>
import _ from 'lodash';
import { UNREAD_FLG } from 'lib-tw-common';
import {getEntityNameByProcessId} from '@/utils/entity'
import TwTableSystem from '@/components/organisms/TwTableSystem';
import schemas from '@/dictionaries/dashBoardNotificationSchema.json';

export default {
  name: 'App',
  props: {
    isEditMode: Boolean,
    isDisabled: Boolean,
  },
  components: {
    TwTableSystem
  },
  data() {
    return {
      schemas: schemas,
      loading: false,
      referenceDate: '',
      getEntityNameByProcessId,
    };
  },
  computed: {
    items() {
      return this.$store.state.notifications;
    },
    unreadOnlyForDashboard: {
      get() {
        return this.$store.getters.getUnreadOnlyNotice;
      },
      set(value) {
        this.$store.commit('SET_UNREAD_ONLY_NOTICE', value);
      }
    }
  },
  created() {
    this.unreadOnlyForDashboard = this.$store.getters.getUnreadOnlyNotice;
    this.fetch();
  },
  watch: {
    unreadOnlyForDashboard() {
      return this.fetch();
    },
  },
  methods: {
    async fetch(referenceDate) {
      await this.$store.dispatch('GET_NOTIFICATION_LIST', {unReadFlg: this.unreadOnlyForDashboard ? UNREAD_FLG.UNREAD : UNREAD_FLG.ALL, sendNotification: false, referenceDate});
    },
    rowClick(row) {
      this.$router.push({
        name: `Process${_.capitalize(row.processId.replace(/\d/g, ''))}`,
        params: { entityId: row.entityId, processSeq: row.processSeq, _processId: row.processId.toLowerCase() },
      })
      .catch(error => {
        if (error.name !== 'NavigationDuplicated') throw error;
      });
      if (!row.read) {
        this.$store.dispatch('READ_NOTIFICATION', row.browserNoticeId);
        this.$store.commit('SET_UNREAD_COUNT', Math.max(this.$store.getters.getUnreadCount - 1, 0));
      }
    },
    async load() {
      const noticeDate = this.items[this.items.length - 1].noticeDate;
      if (this.referenceDate === noticeDate) return
      this.loading = true;
      await this.fetch(noticeDate);
      setTimeout(() => {
        this.referenceDate = this.items[this.items.length - 1].noticeDate;
        this.loading = false;
      }, 200);
    }
  }
};
</script>

<style lang="scss" scoped>
  .tw_dashboard_notification {
    position: relative;
    z-index: 2;

    &.edit {
      pointer-events: none;

      &.disabled:after {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(249, 249, 253, 0.5);
        border-radius: 8px;
        content: '';
      }
    }
  }
</style>